import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./customBaseQuery";

export const employeeContributionApi = createApi({
  reducerPath: "employeeContributionApi",
  baseQuery: customBaseQuery,
  tagTypes: ["EmployeeContribution", "EmployerMatch"],
  endpoints: (builder) => ({
    getEmployeeContributionData: builder.query<
      unknown,
      { employeeID: string; userAccountID: string }
    >({
      query: ({ employeeID, userAccountID }) => ({
        url: `/Employee/Contribution/${employeeID}/UserAccountID/${userAccountID}`,
      }),
      providesTags: (_result, _error, { employeeID, userAccountID }) => [
        { type: "EmployeeContribution", id: `${employeeID}-${userAccountID}` },
        { type: "EmployeeContribution", id: employeeID },
      ],
    }),
  }),
});

export const {
  useGetEmployeeContributionDataQuery,
  useLazyGetEmployeeContributionDataQuery,
} = employeeContributionApi;
